import * as Apollo from '@apollo/client';

import GetCustomersLookUpQuery from '@/graphql/contracts/getCustomersLookUp.query.gql';
import { GetCustomersLookup, GetCustomersLookupVariables } 
  from '@/graphql/contracts/_generated_/getCustomersLookUp.query';

const defaultOptions = { fetchPolicy: 'cache-first' } as const;

export function useGetCustomersAutocompleteListQuery(
  baseOptions?: Apollo.QueryHookOptions<
  GetCustomersLookup,
  GetCustomersLookupVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
  GetCustomersLookup,
  GetCustomersLookupVariables
  >(GetCustomersLookUpQuery, options);
}